export const setTranslationsToStorage = (translationsData: Object) => {
  localStorage.setItem('pwa.translations', JSON.stringify(translationsData));
};
